import { useMutation } from "react-query";
import { exportOutputPDF } from "@/api/Histories/histories-api";

export function useExportOutputPDF() {
	return useMutation(
		async (applicationsIds) => {
			const exportResponse = await exportOutputPDF(applicationsIds);
			const pdfBlob = exportResponse.data;

			const contentDisposition = exportResponse.headers?.["content-disposition"] || "";
			const fileNameMatch = contentDisposition.match(/filename="(.+)"/);
			const downloadedFileName = fileNameMatch?.[1] || "Registro de salida.pdf";

			const url = globalThis.URL.createObjectURL(pdfBlob);
			const link = document.createElement("a");
			link.href = url;
			link.setAttribute("download", downloadedFileName);
			document.body.appendChild(link);
			link.click();
			link.remove();
			globalThis.URL.revokeObjectURL(url);

			return pdfBlob;
		},
		{
			onError: (error) => {
				console.error("Error exporting PDF:", error);
				throw error;
			},
		},
	);
}
